import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'
import { useIsInViewport } from 'hooks/useIsInViewport'
import { useResponsive } from 'hooks/useResponsive'
import { useEffect, RefObject } from 'react'

const useAutoPlayWhenVisible = (
  containerRef: RefObject<HTMLElement | null>,
  videoRef: RefObject<HTMLVideoElement | null>,
  isVideoLoading: boolean
) => {
  const isInViewport = useIsInViewport(containerRef)
  const isMobile = useResponsive(SMALL_DESKTOP_SIZE_BREAKPOINT)

  useEffect(() => {
    if (!videoRef.current || !isMobile || isVideoLoading) return

    if (isInViewport) {
      videoRef.current.play().catch(() => {})
    } else {
      videoRef.current.pause()
    }
  }, [isInViewport, isMobile, isVideoLoading, videoRef])
}

export default useAutoPlayWhenVisible
